import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  fetchUserSuccess,
  fetchUserFailure,
  updateUserSuccess,
  updateUserFailure,
} from '../ProfileUpdate/profileUpdateAction';
import { FETCH_USER_REQUEST, UPDATE_USER_REQUEST } from './profileUpdateTypes';

const API_BASE_URL = 'http://154.61.173.123:7000/user';

function* fetchUserSaga(action) {
  try {
    const response = yield call(
      axios.get,
      `${API_BASE_URL}/getuser/${action.payload}`
    );
    // console.log('API Response:', response.data);
    yield put(fetchUserSuccess(response.data));
  } catch (error) {
    // console.error('Fetch User Error:', error.message);
    yield put(fetchUserFailure(error.message));
  }
}

function* updateUserSaga(action) {
  try {
    // console.log('Payload:', action.payload);
    const response = yield call(
      axios.put,
      `http://154.61.173.123:7000/user/updateuser/${action.payload.id}`,
      action.payload
    );

    yield put(updateUserSuccess(response.data.message));
  } catch (error) {
    // console.error('Error:', error.message);
    yield put(updateUserFailure(error.message));
  }
}

export default function* updateProfileSaga() {
  yield takeLatest(FETCH_USER_REQUEST, fetchUserSaga);
  yield takeLatest(UPDATE_USER_REQUEST, updateUserSaga);
}
